import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhoFor() {
  const audiences = [{
    title: 'Early-Stage Startups',
    image: 'https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    benefits: ['Improve test coverage before growth', 'Strengthen architecture for scale', 'Reduce production risk early']
  }, {
    title: 'Growing Tech Companies',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    benefits: ['Evolve legacy systems safely', 'Accelerate onboarding and velocity', 'De-risk your release process']
  }, {
    title: 'Enterprises Adopting AI',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    benefits: ['Build clear spec foundations', 'Establish clean code boundaries', 'Enable Spec-Driven Development']
  }];
  return <section id="who-for" className="py-24 bg-brand-navy text-white" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-267">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 font-heading" data-id="element-268">
            Who Is BetterCode For?
          </h2>
          <p className="text-lg text-slate-300" data-id="element-269">
            The ROI is highest for teams at critical inflection points in their
            growth journey.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-270">
          {audiences.map((audience, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-brand-navyLight rounded-2xl overflow-hidden border border-slate-800 flex flex-col" data-id="element-271">
              <div className="h-48 relative overflow-hidden bg-brand-navy" data-id="element-272">
                <img src={audience.image} alt={audience.title} loading="lazy" className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-273" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navyLight via-brand-navyLight/40 to-transparent" data-id="element-274" />
              </div>
              <div className="p-8 flex-1 flex flex-col" data-id="element-275">
                <h3 className="text-2xl font-bold mb-6 font-heading text-white" data-id="element-276">
                  {audience.title}
                </h3>
                <ul className="space-y-4 mt-auto" data-id="element-277">
                  {audience.benefits.map((benefit, bIndex) => <li key={bIndex} className="flex items-start" data-id="element-278">
                      <CheckCircle2 className="h-5 w-5 text-brand-green mr-3 flex-shrink-0 mt-0.5" data-id="element-279" />
                      <span className="text-slate-300 text-sm leading-relaxed" data-id="element-280">
                        {benefit}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}